/**
 * 判断对象中所有值是否都为空
 * @param {Object} obj - 需要检查的对象
 * @param {Object} [options] - 可选配置
 * @param {boolean} [options.ignoreWhitespace=false] - 是否将空格视为非空
 * @param {boolean} [options.considerZeroAsEmpty=false] - 是否将0视为空
 * @returns {boolean} - 所有值都为空返回true，否则返回false
 */

export function allValuesEmpty(obj, options = {}) {
  // 处理非对象情况
  if (obj === null || typeof obj !== "object" || Array.isArray(obj)) {
    throw new Error("参数必须是一个对象");
  }

  const { ignoreWhitespace = false, considerZeroAsEmpty = false } = options;

  // 判断单个值是否为空
  const isEmpty = value => {
    // 处理null和undefined
    if (value == null) return true;

    // 处理数字0
    if (considerZeroAsEmpty && value === 0) return true;

    // 处理字符串
    if (typeof value === "string") {
      return ignoreWhitespace ? value === "" : value.trim() === "";
    }

    // 处理数组
    if (Array.isArray(value)) return value.length === 0;

    // 处理对象
    if (typeof value === "object") return Object.keys(value).length === 0;

    // 其他类型视为非空
    return false;
  };

  // 检查所有值
  return Object.values(obj).every(isEmpty);
}

// // 示例用法
// const testObj1 = { name: '', age: null, address: {} };
// const testObj2 = { name: ' ', age: 0, hobbies: [] };
// const testObj3 = { name: '张三', age: 20, address: { city: '北京' } };
